<div class="row">
  <div class="col-lg-8">
    <div class="mb-4">
      <ng-container [ngTemplateOutlet]="customerCard"></ng-container>
    </div>
  </div>
  <div class="col-lg-4">
    <retail-order-info (back)="back.emit()" (next)="continue()" continueLabel="Finish the order">
      <div class="row no-gutters pt-3">
        <mat-checkbox class="col-auto" [(ngModel)]="checked"></mat-checkbox>
        <div class="col">
          <div>{{ 'I agree to the terms and conditions and acknowledge the processing of personal data.' | t }}</div>
          <mat-error *ngIf="submitted && !checked" class="pt-2">{{ 'You must agree to the terms.' | t }}</mat-error>
        </div>
      </div>
    </retail-order-info>
  </div>
</div>

<ng-template #customerCard>
  <div *ngIf="order">
    <div class="mb-4">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'Billing Info' | t }}</mat-card-title>
          <mat-card-subtitle>&nbsp;</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <b>{{ order.info.firstname }} {{ order.info.lastname }}</b>
          <br />
          <span>{{ order.info.street }}</span>
          <br />
          <span>{{ order.info.postalcode }} {{ order.info.city }}</span>
          <br />
          <span>{{ CountryLabels[order.info.country] }}</span>
          <br />
          <span>E-mail: {{ order.info.email }}</span>
          <br />
          <span>Tel.: {{ order.info.phone }}</span>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="mb-4">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'Delivery Info' | t }}</mat-card-title>
          <mat-card-subtitle>&nbsp;</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content *ngIf="order.info.delivery">
          <b>{{ order.info.deliveryName }}</b>
          <br />
          <span>{{ order.info.deliveryStreet }}</span>
          <br />
          <span>{{ order.info.deliveryPostalcode }} {{ order.info.deliveryCity }}</span>
          <br />
          <span>{{ CountryLabels[order.info.deliveryCountry] }}</span>
        </mat-card-content>
        <mat-card-content *ngIf="!order.info.delivery">
          <b>{{ order.info.firstname }} {{ order.info.lastname }}</b>
          <br />
          <span>{{ order.info.street }}</span>
          <br />
          <span>{{ order.info.postalcode }} {{ order.info.city }}</span>
          <br />
          <span>{{ CountryLabels[order.info.country] }}</span>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</ng-template>
